var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2C12.3956 2 13.0933 2 13.6611 2.17224C14.9395 2.56004 15.94 3.56046 16.3278 4.83886C16.5 5.40666 16.5 6.10444 16.5 7.5L16.5 10.5C16.5 11.8956 16.5 12.5933 16.3278 13.1611C15.94 14.4395 14.9395 15.44 13.6611 15.8278C13.0933 16 12.3956 16 11 16V16C9.60444 16 8.90666 16 8.33886 15.8278C7.06045 15.44 6.06004 14.4395 5.67224 13.1611C5.5 12.5933 5.5 11.8956 5.5 10.5L5.5 7.5C5.5 6.10444 5.5 5.40666 5.67224 4.83886C6.06004 3.56046 7.06046 2.56004 8.33886 2.17224C8.90666 2 9.60444 2 11 2V2Z",
    stroke: "#5E666E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4C10.3956 4 11.0933 4 11.6611 4.17224C12.9395 4.56004 13.94 5.56046 14.3278 6.83886C14.5 7.40666 14.5 8.10444 14.5 9.5L14.5 12.5C14.5 13.8956 14.5 14.5933 14.3278 15.1611C13.94 16.4395 12.9395 17.44 11.6611 17.8278C11.0933 18 10.3956 18 9 18C7.60444 18 6.90666 18 6.33886 17.8278C5.06045 17.44 4.06004 16.4395 3.67224 15.1611C3.5 14.5933 3.5 13.8956 3.5 12.5L3.5 9.5C3.5 8.10444 3.5 7.40666 3.67224 6.83886C4.06004 5.56046 5.06046 4.56004 6.33886 4.17224C6.90666 4 7.60444 4 9 4Z",
    fill: "#F9FAFA",
    stroke: "#5E666E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.96543016096b05b3444454895deae4c3.svg";
export { ForwardRef as ReactComponent };